
                  export default function (Component) {
                      Component.__source = "library/components/VabBreadcrumb/index.vue"
                  }
              